import React from 'react';
import { IconButton } from '@mui/material';
import footerStyle from '../footerStyle';

const SocialIcon = ({ href, icon: Icon }) => {
  const classes = footerStyle();
  return (
    <IconButton href={href} target="_blank" className={classes.icon}>
      <Icon />
    </IconButton>
  );
};

export default SocialIcon;